import { render, staticRenderFns } from "./Actedite.vue?vue&type=template&id=23d6540c&scoped=true"
import script from "./Actedite.vue?vue&type=script&lang=js"
export * from "./Actedite.vue?vue&type=script&lang=js"
import style0 from "./Actedite.vue?vue&type=style&index=0&id=23d6540c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d6540c",
  null
  
)

export default component.exports